import { InjectionToken } from '@angular/core';

export const MOMENT = new InjectionToken('moment');
